// extracted by mini-css-extract-plugin
export default {"title":"uG_sk","info":"uG_sh","info_cancelled":"uG_uH","info_simulated":"uG_uI","text":"uG_uJ","win":"uG_uK","lose":"uG_uL","net":"uG_uM","date":"uG_uN","refunded":"uG_uO"};